import { Inject, Injectable } from '@angular/core';
import { isNil } from 'lodash-es';
import { environment } from '../environments/environment';

import { UtilsService } from './utils.service';
import { SettingsValuesService } from './settings.values.service';

@Injectable({ providedIn: 'root' })
export class app_custom_ds_get_license_plate_details_by_licensePlateId_v2Service {

  constructor(
    private $utils: UtilsService,
    private $settings: SettingsValuesService,
    ) { 
  }

  public async get($inParams: { licensePlateIds?: number[], lotIds?: number[], warehouseIds?: number[], locationIds?: number[], materialIds?: number[] }): 
  Promise<{ result: { PackagedAmount?: number, LicensePlateLookupCode?: string, LicensePlateStatus?: string, LicensePlateType?: string, LotLookupCode?: string, VendorLotLookupCode?: string, ProjectLookupCode?: string, MaterialLookupCode?: string, ShipmentId?: number, LicensePlateId?: number, Lot?: { Id?: number, Material?: { Id?: number }, VendorLot?: { Id?: number } }, Packaged?: { Id?: number, Name?: string }, LicensePlate?: { Location?: { Id?: number, Name?: string, Warehouse?: { Id?: number } } } }[] }> 
  {
    let $url = `${environment.backendUrl}api/`;
    
    const $options = {
    }
    
    const $body = $inParams;
    
    return this.$utils.http.post($url, $body, $options);
    
  }
  public async getList($inParams: { licensePlateIds?: number[], lotIds?: number[], warehouseIds?: number[], locationIds?: number[], materialIds?: number[], $top?: number, $skip?: number }): 
  Promise<{ result: { PackagedAmount?: number, LicensePlateLookupCode?: string, LicensePlateStatus?: string, LicensePlateType?: string, LotLookupCode?: string, VendorLotLookupCode?: string, ProjectLookupCode?: string, MaterialLookupCode?: string, ShipmentId?: number, LicensePlateId?: number, Lot?: { Id?: number, Material?: { Id?: number }, VendorLot?: { Id?: number } }, Packaged?: { Id?: number, Name?: string }, LicensePlate?: { Location?: { Id?: number, Name?: string, Warehouse?: { Id?: number } } } }[], totalCount: number }> 
  {
    let $url = `${environment.backendUrl}api/`;
    
    const $options = {
    }
    
    const $body = $inParams;
    
    return this.$utils.http.post($url, $body, $options);
    
  }
  public async getByKeys($inParams: { licensePlateIds?: number[], lotIds?: number[], warehouseIds?: number[], locationIds?: number[], materialIds?: number[], $keys: { LicensePlateId?: number, Lot?: { Material?: { Id?: number }, Id?: number, VendorLot?: { Id?: number } }, Packaged?: { Id?: number, Name?: string }, LicensePlate?: { Location?: { Id?: number, Warehouse?: { Id?: number }, Name?: string } } }[] }): 
  Promise<{ result: { PackagedAmount?: number, LicensePlateLookupCode?: string, LicensePlateStatus?: string, LicensePlateType?: string, LotLookupCode?: string, VendorLotLookupCode?: string, ProjectLookupCode?: string, MaterialLookupCode?: string, ShipmentId?: number, LicensePlateId?: number, Lot?: { Id?: number, Material?: { Id?: number }, VendorLot?: { Id?: number } }, Packaged?: { Id?: number, Name?: string }, LicensePlate?: { Location?: { Id?: number, Name?: string, Warehouse?: { Id?: number } } } }[] }> 
  {
    const $missingRequiredInParams = [];
    if (isNil($inParams.$keys)) {
      $missingRequiredInParams.push('\'$keys\'');
    }
    if ($missingRequiredInParams.length) {
    }
    let $url = `${environment.backendUrl}api/`;
    
    const $options = {
    }
    
    const $body = $inParams;
    
    return this.$utils.http.post($url, $body, $options);
    
  }


    
    hasMissingRequiredInParams($inParams: { 
      licensePlateIds?: number[], lotIds?: number[], warehouseIds?: number[], locationIds?: number[], materialIds?: number[]    }) {
      return false;
    }
}
